var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-offer-status flex-end"},[_c('Badge',{staticClass:"offer-badge",attrs:{"color":_vm.badgeByStatus}},[_vm._v("\n    "+_vm._s(_vm.tenderOfferStatuses[_vm.status])+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }